import { render } from "./UserActivityView.vue?vue&type=template&id=6941e7fb&scoped=true"
import script from "./UserActivityView.vue?vue&type=script&lang=js"
export * from "./UserActivityView.vue?vue&type=script&lang=js"

import "./UserActivityView.vue?vue&type=style&index=0&id=6941e7fb&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6941e7fb"]])

export default __exports__